/**
 * 项目管理
 */

import { FullChildContainer } from '@acgn/herm/src/components';

const comicAuthRoutes: any = {
  path: 'comic-auth',
  name: '项目管理',
  icon: 'ift-project_1',
  meta: {
    breadcrumbHidden: true
  },
  component: FullChildContainer,
  children: [
    {
      path: '',
      redirect: 'list'
    },
    {
      path: 'list',
      redirect: 'list',
      name: '项目管理',
      component: FullChildContainer,
      children: [
        {
          path: '',
          name: 'desk-comicAuthList',
          meta: {
            text: '项目列表',
            type: 'list',
            role: ['1002']
          },
          component: () => import('../views/comic-auth/list.vue')
        },
        {
          path: 'detail/:id',
          name: 'desk-comicAuthDetail',
          meta: {
            text: '项目详情',
            type: 'detail',
            role: ['1006']
          },
          component: () => import('../views/comic-auth/detail.vue')
        },
        {
          path: 'task/:id/:task_group_id/:task_id',
          name: 'desk-comicAuthTask',
          meta: {
            text: '项目详情',
            type: 'detail',
            role: ['1003']
          },
          component: () => import('../views/comic-auth/task.vue')
        },
        {
          path: 'add',
          name: 'desk-comicAuthAdd',
          meta: {
            text: '创建项目',
            type: 'add',
            role: ['1004']
          },
          component: () => import('../views/comic-auth/edit.vue')
        },
        {
          path: 'statistic',
          name: 'desk-comicAuthStatistic',
          meta: {
            text: '项目详情',
            type: 'detail',
            role: []
          },
          component: () => import('../views/comic-auth/statistic.vue')
        },
        {
          path: 'edit/:id',
          name: 'desk-comicAuthEdit',
          meta: {
            text: '编辑项目',
            type: 'edit',
            role: ['1005']
          },
          component: () => import('../views/comic-auth/edit.vue')
        },
      ]
    }
  ]
};

export {
  comicAuthRoutes
};
